var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.taxies)?_c('div',{staticClass:"sidebar__taxies__group"},[_c('strong',{staticClass:"sidebar__taxies__groupTitle"},[_vm._v(_vm._s(_vm.label))]),_c('ul',{staticClass:"sidebar__taxies__groupItems",class:{ 'sidebar__taxies__groupItems--inline': _vm.itemStyle == 'inline' }},_vm._l((_vm.taxies),function(tax,i){return _c('li',{key:i,staticClass:"sidebar__taxies__groupItems__item"},[_c('router-link',{attrs:{"to":{
          name: _vm.sessionType,
          params: { postType: _vm.postType },
          query: _vm.mkQueryObj(tax),
        }}},[_vm._v(_vm._s(tax.name))])],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }